module.exports = __webpack_public_path__ + "img/ZB53详情页_08.ff378897.jpg";